import { useContext, useReducer, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthContext, UserContext } from '../App';
import useToast from './useToast';

const errorReducer = (state, action) => {
  switch (action.type) {
    case 'SET_ERROR':
      return { error: action.payload };
    case 'CLEAR_ERROR':
      return { error: null };
    default:
      return state;
  }
};

function useErrorHandling() {
  const navigate = useNavigate();
  const { setAuth } = useContext(AuthContext);
  const { setUser } = useContext(UserContext);
  const { makeToast } = useToast();
  const [error, setError] = useState();

  const [errorState, dispatch] = useReducer(errorReducer, { error: null });

  useEffect(() => {
    if (errorState.error) {
      if (errorState.error.code === 401) {
        makeToast(
          'You are being logged out due to session refresh',
          'negative-red',
          ['far', 'octagon-xmark'],
        );
        setAuth(null);
        setUser(null);
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      }
      if (errorState.error.code === 500) {
        makeToast(
          'Whoops, something went wrong! Please contact Credit Key Support for assistance: (844) 334-3636',
          'negative-red',
          ['far', 'octagon-xmark'],
        );
        navigate('/support');
      }
    } else {
      dispatch({ type: 'CLEAR_ERROR' });
      setError(errorState.error)
    }

  }, [errorState.error]);

  return { dispatch, error };
}

export default useErrorHandling;
